/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {ProfessionalReference} from './professional-reference.model';
import {UserModelListService} from '../common/user-model-list.service';
import {Service} from '../common/service.class';

@Injectable()
export class ProfessionalReferenceService extends UserModelListService<ProfessionalReference> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'professionalReference', ProfessionalReference);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/reference/professional-reference.service.ts